module.controller('lifeProofcameraCntrl', function ($location, $document, esb, xmppAuth, services, $scope, $mdDialog, $window, theme, cryptool) {
  var xmpp_domain = cryptool.decryptData($window.sessionStorage.getItem("serviceName"));
  var xmppUser = $window.sessionStorage.getItem('userXmpp');
   
  var defaultCam = $window.sessionStorage.getItem("defaultCamera");
  var defaultCamera = defaultCam || "back"
  var imageCapture;
  var snapshotBlob;
  $scope.data = JSON.parse($window.localStorage.getItem("metadataObj"));
  $scope.theme = theme.getTheme();
  $scope.mask = $scope.data.constraints.mask; 
  $scope.needMask = true;
  $scope.maskLandscape = false; 
  
  var messageTexts = [{text: 'Preparate se te tomará una foto', time: 300}, {text: '¿Listo?', time: 3} , {text: 'Empecemos', time: 3}, {text: '3', time: 1}, {text: '2', time: 1}, {text: '1', time: 1}]

  if($location.search().tag!=null && $location.search().tag!='undefined' && $location.search().user_teller_agent!=null
                            && $location.search().user_teller_agent!='undefined' && ($window.navigator.userAgent=== 'commerce-mobile' ||
                             ($location.search().mode!=null && $location.search().mode === 'asesorweb') )){
                            
                            }
  var mobileAndTabletCheck = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };
  $scope.mobile = mobileAndTabletCheck();
  if($window.navigator.userAgent=== 'commerce-mobile') {
    $scope.mobile = true;
  }
  var currentWidth = 480;
  var currentHeight = 320;
  if($scope.mobile) {
    currentWidth = 320;
    currentHeight = 480;
  }
  $scope.hasImageCapture = false;
   
  navigator.mediaDevices.enumerateDevices().then(gotDevices).then(start).catch(handleError);
 

  function gotDevices(deviceInfos) {
    const audioInputSelect = document.querySelector('select#audioSource');
    const audioOutputSelect = document.querySelector('select#audioOutput');
    const videoSelect = document.querySelector('select#videoSource');
    const selectors = [audioInputSelect, audioOutputSelect, videoSelect];
    const values = selectors.map(select => select.value);
    selectors.forEach(select => {
      while (select.firstChild) {
        select.removeChild(select.firstChild);
      }
    });
    for (let i = 0; i !== deviceInfos.length; ++i) {
      const deviceInfo = deviceInfos[i];
      const option = document.createElement('option');
      option.value = deviceInfo.deviceId;
      if (deviceInfo.kind === 'audioinput') {
        option.text = deviceInfo.label || `microphone ${audioInputSelect.length + 1}`;
        audioInputSelect.appendChild(option);
      } else if (deviceInfo.kind === 'audiooutput') {
        option.text = deviceInfo.label || `speaker ${audioOutputSelect.length + 1}`;
        audioOutputSelect.appendChild(option);
      } else if (deviceInfo.kind === 'videoinput') {
        option.text = deviceInfo.label || `camera ${videoSelect.length + 1}`;
        videoSelect.appendChild(option);
        console.log(option.text + "---" + option.value);
      } else {
        console.log('Some other kind of source/device: ', deviceInfo);
      }
    }
    selectors.forEach((select, selectorIndex) => {
      if (Array.prototype.slice.call(select.childNodes).some(n => n.value === values[selectorIndex])) {
        select.value = values[selectorIndex];
      }
    });
    // if videoSelect.selectedIndexForced is true, do not try to select default camera
    if(videoSelect.length > 1 && !videoSelect.selectedIndexForced) {
      for (var i = 0; i < videoSelect.length; i++) {
        if (videoSelect[i].text.toLowerCase().search(defaultCamera.toLowerCase()) != -1) {
          videoSelect.selectedIndex = i;
          videoSelect.value = videoSelect.options[i].value;
          return;
        }
      }
    }
   
  }

  function gotStream(stream) {
    const videoElement = document.getElementById('videoImage');
    window.stream = stream; // make stream available to console
    videoElement.srcObject = stream;
    // Refresh button list in case labels have become available
    return navigator.mediaDevices.enumerateDevices();
  }

  function handleError(error) {
    console.log('navigator.MediaDevices.getUserMedia error: ', error.message, error.name);
  }

  function start() {
    if (window.stream) {
      window.stream.getTracks().forEach(track => {
        track.stop();
      });
    }

    const videoSelect = document.querySelector('select#videoSource');
    const videoSource = videoSelect.value;
    const constraints = {
      audio: false,
      video: {
        deviceId: videoSource ? {
          exact: videoSource
        } : undefined,
        width: 1440,
        height: 960
      }
    };

    navigator.mediaDevices.getUserMedia(constraints).then(gotStream).then(gotDevices).catch(handleError);
  }

  let cameraIndex = 1;
  function changeCameraClick() {
   
    const videoSelect = document.querySelector('select#videoSource');

    const options = videoSelect.options;
    const videoSource = options[videoSelect.selectedIndex];
    if (videoSelect.length == 1) {
      return;
    }

    if (navigator.userAgent === 'commerce-mobile') {
      if (cameraIndex == videoSelect.length) {
        cameraIndex = 0;
        $scope.maskLandscape = false;
      } else {
        $scope.maskLandscape = true;
      }

      videoSelect.selectedIndex = cameraIndex;
      cameraIndex = cameraIndex + 1;
      start();


    } else {

      const typeCameraSearch = videoSource.text.toLowerCase().search("front") === -1 ? "front" : "back";

      for (var i = 0; i < videoSelect.length; i++) {

        var cam = "frontal";
        $scope.maskLandscape = false;
        if (typeCameraSearch != "front") {
          cam = "trasera";
          $scope.maskLandscape = true;
         

        }
        if($scope.needMask)
          drawTemplate()
        if (videoSelect[i].text.toLowerCase().search(typeCameraSearch) != -1 || videoSelect[i].text.toLowerCase().search(cam) != -1) {
          videoSelect.selectedIndex = i;
          videoSelect.value = videoSelect.options[i].value;
          videoSelect.selectedIndexForced = true;    // if videoSelect.selectedIndexForced is true, do not try to select default camera
          start();
          return;
        }
      }

    }
  }

  $scope.getVideoSize = function () { 
    const btnChangeCamera = document.querySelector('button#changeCamera');
    btnChangeCamera.onclick = changeCameraClick;  
    
  };

  $scope.canvas = document.createElement('canvas');
   
  function setInRange(value, range) {
    if (!range) return NaN;
    let x = Math.min(range.max, Math.max(range.min, value));
    x = Math.round(x / range.step) * range.step;
    return x;
  }

  $scope.closeDialog = function () {
    $mdDialog.cancel();
    stopCamera();
  }

  $scope.hideDialog = function () {
    $mdDialog.hide();
    stopCamera();
  }

  var showAlert = function(message) {
    $mdDialog.show(
        $mdDialog.alert()
            .parent(angular.element(document.querySelector('#popupContainer')))
            .clickOutsideToClose(false)
            .textContent(message)
            .ok('Ok')
            .ariaLabel('Alert Dialog')
    ).then(function() {
      if(document.getElementById("inputSimple"))
        document.getElementById("inputSimple").focus();
    })
  };

  $scope.makeSnapshotV2 = function () {
    $scope.snapshot1 = "ok";
    $scope.snapshot2 = "ok";
    var patCanvas = document.querySelector('#snapshot1');
    if (!patCanvas) return;
    
    var video = document.querySelector('#videoImage');
    patCanvas.width = video.videoWidth;
    patCanvas.height = video.videoHeight;
    patCanvas.getContext('2d').drawImage(video, 0, 0, patCanvas.width, patCanvas.height);

  }

  $scope.changeCamera = function () {
    const videoSelect = $document.find('select.videoSource');
    const videoSource = videoSelect.value;

    console.log(videoSelect.length);
    if (videoSelect.length == 1) {
      return;
    }
    const typeCameraSearch = videoSource.search("front") === -1 ? "front" : "back";

    alert(typeCameraSearch);
    for (i = 0; i < videoSelect.length; i++) {
      if (videoSelect[i].value.search(typeCameraSearch) != -1) {
        videoSelect.selectedIndex = i;
        videoSelect.value = videoSelect.options[i].value;
      }
    }
  }

  function stopCamera() {
    if ($window.stream) {
      $window.stream.getTracks().forEach(track => {
        track.stop();
      });
    }
  }


  var _video = null,
    patData = null;

  $scope.patOpts = {
    x: 0,
    y: 0,
    w: 25,
    h: 25
  };

  $scope.channel = {
    // the fields below are all optional
    videoHeight: 1000,
    videoWidth: 600,
    video: null // Will reference the video element on success
  };

  $scope.webcamError = false;
  $scope.onError = function (err) {
    $scope.error = true;
    console.log("here error");
    $scope.$apply(
      function () {
        $scope.webcamError = err;
      }
    );
  };

  $scope.onSuccess = function () {
    // The video element contains the captured camera data
    _video = $scope.channel.video;
    $scope.$apply(function () {
      $scope.patOpts.w = _video.width;
      $scope.patOpts.h = _video.height;
      //$scope.showDemos = true;
    });
  };

  $scope.onStream = function (stream) {
    // You could do something manually with the stream.
  };

  $scope.makeSnapshot = function () {
    if (_video) {
      $scope.snapshot = "ok";
      var patCanvas = document.querySelector('#snapshot');
      if (!patCanvas) return;
      patCanvas.width = _video.width;
      patCanvas.height = _video.height;
      var ctxPat = patCanvas.getContext('2d');
      var idata = getVideoData($scope.patOpts.x, $scope.patOpts.y, $scope.patOpts.w, $scope.patOpts.h);
      ctxPat.putImageData(idata, 0, 0);
      sendSnapshotToServer(patCanvas.toDataURL());
      patData = idata;
    }
  };
  $scope.sendPicture = function () {    
    var patCanvas = document.querySelector('#snapshot1');
    let image = patCanvas.toDataURL("image/png")    
    localStorage.setItem("selfieData", image);
    localStorage.setItem("selfieDataWidth", patCanvas.width);
    localStorage.setItem("selfieDataHeight", patCanvas.height);
    $scope.hideDialog();    
  }   

  $scope.downloadSnapshot = function downloadSnapshot(dataURL) {
    window.location.href = dataURL;
  };

  var getVideoData = function getVideoData(x, y, w, h) {
    var hiddenCanvas = document.createElement('canvas');
    hiddenCanvas.width = _video.width;
    hiddenCanvas.height = _video.height;
    var ctx = hiddenCanvas.getContext('2d');
    ctx.drawImage(_video, 0, 0, _video.width, _video.height);
    return ctx.getImageData(x, y, w, h);
  };

  $scope.goBack = function() {
    $scope.snapshot2 = undefined
    $scope.snapshot1 = undefined   
    $scope.showBeginButton = true
  }

  var sendSnapshotToServer = function sendSnapshotToServer(imgBase64) {
    $scope.snapshotData = imgBase64;
  };

  var textIndex = 0
  var itemText = document.createElement("h1")   
  function showMessage() {
    var containerText = document.getElementById('containerText')
    containerText.innerHTML = '';
    itemText = document.createElement("h1") 

    itemText.className = textIndex > 2 ? "fadeout" : 'textH1'
    itemText.innerHTML = messageTexts[textIndex].text
    console.log(messageTexts[textIndex].text)
    containerText.appendChild(itemText)   
    textIndex++

    if((textIndex + 1) > messageTexts.length) {      
      clearInterval(timer) 
      setTimeout(() => { textIndex = 0;  document.getElementById('containerText').innerHTML = '';  $scope.makeSnapshotV2()}, 1000)
    }
      
  }  
  var timer = 0
  $scope.showBeginButton = true
  $scope.letsBegin = function () {
    $scope.showBeginButton = false
    createLoop(messageTexts, function(obj) {console.log(obj.text)}, 1000)
  }

  function createLoop(array, delegate, delay) {
    var totalTime = 0
    array.forEach(function (e, i) {
      totalTime += array[i].time
      setTimeout(function() {          
          showMessage()
        }, totalTime * delay);
    })   
  } 

});
